import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheConsultantCybersecurite = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          🔐 Recruter un Consultant en Cybersécurité
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          Le Consultant en Cybersécurité évalue, conseille et renforce la sécurité des systèmes d'information. Face à la multiplication des attaques, son rôle est devenu stratégique pour prévenir les risques, protéger les données sensibles et garantir la conformité réglementaire (RGPD, ISO 27001…). Il intervient en audit, en gestion de crise ou dans la mise en œuvre de solutions de sécurité sur mesure.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Réaliser des audits de sécurité (technique, organisationnel, applicatif)</li>
          <li>Identifier les vulnérabilités et proposer des plans d’action correctifs</li>
          <li>Accompagner la mise en conformité (RGPD, ISO, NIS…)</li>
          <li>Définir des politiques de sécurité (PSSI, gestion des accès, plans de continuité)</li>
          <li>Sensibiliser les équipes internes (phishing, bonnes pratiques)</li>
          <li>Intervenir en cas d'incident ou de faille de sécurité</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Outils : SIEM, EDR, IDS/IPS, scanners de vulnérabilité (Nessus, Qualys…)</li>
          <li>Connaissances en réseau, systèmes, cloud et sécurité applicative</li>
          <li>Maîtrise des normes : ISO 27001, RGPD, NIST, OWASP</li>
          <li>Capacité d’analyse, rigueur, discrétion et pédagogie</li>
          <li>Expérience en gestion des risques et sécurité offensive/défensive</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : appui à l’audit, gestion des droits, supervision SOC</li>
          <li>Confirmé : réalisation d’audits, coordination sécurité projet</li>
          <li>Senior : rôle de RSSI externe, gestion de crise, stratégie globale sécurité</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 350–450 € / jour</li>
          <li>Confirmé : 500–700 € / jour</li>
          <li>Senior / RSSI externalisé : 750–1 000 € / jour</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheConsultantCybersecurite;
